module.exports = __webpack_public_path__ + "static/media/watch-video.8feb9ff7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/watch-video.png
// module id = 687
// module chunks = 0